import Enums from 'utils/EnumsManager';
import { RESET_VIEW_GLOBAL } from 'store/global/actionType';
export const RESET_VIEW = RESET_VIEW_GLOBAL;

const { VIEWFILTER } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_AVAILABLE_FIELDS = VIEWFILTER + 'SET_AVAILABLE_FIELDS';
export const SET_NEW_ORDER = VIEWFILTER + 'SET_NEW_ORDER';
export const ADD_TO_SELECTION = VIEWFILTER + 'ADD_TO_SELECTION';
export const REMOVE_FROM_SELECTION = VIEWFILTER + 'REMOVE_FROM_SELECTION';
export const RESET_SELECTED_FIELDS = VIEWFILTER + 'RESET_SELECTED_FIELDS';
export const SET_ISDEFAULT_FIELD = VIEWFILTER + 'SET_ISDEFAULT_FIELD';



// WEBPACK FOOTER //
// ./src/components/page/ObjectFilter/components/FieldsSelection/flow/actionTypes.js